import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraHyperstarOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M7.526 1c2.713 0 4.231.611 4.949 2.238.177.402.305.865.39 1.397l1.91-1.135H16v9h-1.225l-1.91-1.135a5.7 5.7 0 0 1-.39 1.397C11.757 14.389 10.239 15 7.526 15H5.474C1.369 15 0 13.6 0 9.4V7.333h1.4V9.4c0 2.028.349 2.937.798 3.397.44.45 1.307.803 3.276.803h2.052c1.61 0 2.492-.237 2.998-.575.429-.286.782-.777.96-1.881l.326-2.034 2.79 1.658V5.232L11.81 6.89l-.327-2.034c-.178-1.104-.53-1.595-.959-1.881-.506-.338-1.387-.575-2.998-.575H6.333V1z"
                    fill="currentColor"
                />
                <path
                    d="M2.5 1A9.5 9.5 0 0 0 5 3.5 9.5 9.5 0 0 0 2.5 6 9.5 9.5 0 0 0 0 3.5 9.5 9.5 0 0 0 2.5 1"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
VideocameraHyperstarOutlinedSize16Glyph.displayName = 'VideocameraHyperstarOutlinedSize16Glyph';
